export default __webpack_public_path__ + "static/media/project (5).e2f5bbd9.png";